<template>
    <div id="dues_invoice_body">
        <internal-header v-if="!pdf_view" heading="Dues Invoice"/>
        <dues-invoice-report-filters
            v-if="$vuetify.breakpoint.mdAndUp && !pdf_view"
            v-model="filters"
            :constants="constants"
            :valuelists="valuelists"
        />
        <v-expansion-panels v-else-if="!pdf_view" flat>
            <v-expansion-panel>
                <v-expansion-panel-header hide-actions>
                    <template v-slot:default="{ open }">
                        <v-container class="py-0">
                            <v-row no-gutters>
                                <v-col cols="11" class="tw-text-lg">Filters<span v-show="!!filters_used">: {{ filters_used }}</span></v-col>
                                <v-col cols="1">
                                    <v-icon>
                                        <template v-if="open">mdi-minus-circle</template>
                                        <template v-else>mdi-plus-circle</template>
                                    </v-icon>
                                </v-col>
                            </v-row>
                        </v-container>
                    </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <dues-invoice-report-filters
                        v-model="filters"
                        :constants="constants"
                        :valuelists="valuelists"
                        class="hidden-filters"
                    />
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>
        <div class="tw-flex tw-flex-row tw-w-full tw-justify-between tw-items-center tw-pt-2 tw-pb-1 tw-border-b tw-border-t tw-border-dark-grey">
            <div v-if="!pdf_view" v-show="records_are_present" @click="exportAsPdf()" class="flex-grow-0 tw-px-3 tw-text-black tw-underline tw-text-xs tw-font-normal tw-text-link tw-cursor-pointer">Print List</div>
        </div>
        <div class="account-information">
            <div class="tw-text-center tw-font-bold tw-text-xl tw-mb-4">
                DUES INVOICE/STATEMENT
            </div>
            <div class="tw-flex tw-justify-between">
                <span>Date: {{ currentDate }}</span>
                <span>Account Number: {{ accountNumber }}</span>
            </div>
            <hr>
            <br>
            <div class="mt-5 mb-5">
                {{ firstName }} {{ lastName }}
                <br>
                {{ address1 }},
                <br>
                {{ city }} {{ provinceAbbreviation }} {{ postalCode }}
            </div>
            <br>
        </div>
        <smart-table
            ref="report_list"
            endpoint="reports.list.duesinvoice"
            :pdf_endpoint="route('reports.duesinvoice.queue', 'pdf').url()"
            :excel_endpoint="route('reports.duesinvoice.queue', 'excel').url()"
            :items="items"
            :hide-default-footer="pdf_view"
            :headers="headers"
            :search="filters.search"
            :multi-sort="true"
            :items-per-page="getDefaultItemsPerPage()"
            :footer-props="{
                'items-per-page-options': getDefaultItemsPerPageOptions()
            }"
            flat
            @fetch-complete="receivedRecordsUpdate"
            export_endpoint="reports.export.duesinvoice"
            export_endpoint_method="post"
            export_filename="export.xls"
            id="dues-invoice-table"
        >
            <template v-slot:item.current_year="{ isMobile, item, header, value, index}">
                {{ displayYear(item) }}
            </template>
            <template #footer>
                <div class="tw-flex">
                    <div class="tw-border tw-border-black tw-p-4 tw-mt-4 tw-flex tw-flex-row tw-flex-wrap">
                        <div class="tw-flex tw-w-3/12 tw-mt-2">
                            <v-text-field :value="balance_previous" label="Balance Previous" readonly></v-text-field>
                        </div>
                        <div class="tw-flex tw-items-center mx-1"><span>+</span></div>
                        <div class="tw-flex tw-w-3/12 tw-mt-2">
                            <v-text-field :value="balance_current" label="Balance Statement" readonly></v-text-field>
                        </div>
                        <div class="tw-flex tw-items-center mx-1"><span>=</span></div>
                        <div class="tw-flex tw-w-3/12 tw-mt-2">
                            <v-text-field :value="balance_previous + balance_current" label="Balance Due" readonly></v-text-field>
                        </div>
                    </div>
                </div>
                <div>
                    <p class="mt-3"><b>Payment Options:</b></p>
                    <p>1. Internet or Telephone banking through CIBC, TD Canada Trust, Scotia Bank, Bank of Montreal, ING or Royal Bank. You will be required to enter an account number. Our payee name is <b>I.A.T.S.E. Local 667</b>
                    <br>Your unique account number for internet banking is: {{ accountNumber }}
                    </p>
                    <p>2. Credit Card/Debit – you can pay in person at the IATSE 667 office or contact the office to receive an invoice for payment.</p>
                    <p>3. By cheque - please ensure your name is clearly indicated on your cheque.</p>
                    <p>4. Any questions regarding dues or payment please reach out to camera@iatse667.com / 416-368-0072</p>
                </div>
            </template>
        </smart-table>
    </div>
</template>

<script>
    import SmartTable from "@/Generic/SmartTable";
    import AppLayout from "@/Layouts/AppLayout.vue";
    import InternalHeader from "@/Generic/InternalHeader.vue";
    import DuesInvoiceReportFilters from "@/Pages/InternalPages/Reports/DuesInvoiceReportFilters.vue";

    export default {
        name: "DuesInvoiceReport",
        layout: (h, page) => {
            return h(AppLayout, [
                page
            ])
        },
        components: {
            InternalHeader,
            SmartTable,
            DuesInvoiceReportFilters,
        },
        remember: {
            data: [
                'items'
            ]
        },
        props: {
            'constants': {
                type: Object,
                required: false,
                default: function () {
                    return undefined
                }
            },
            'valuelists': {
                type: Object,
                required: false,
                default: function () {
                    return undefined
                }
            },
            'member': {
                type: Object,
                required: false,
                default: function () {
                    return undefined
                }
            },
            'balanceData': {
                type: Object,
                required: false,
                default: function () {
                    return undefined
                }
            },
            'items': {          // Will optionally accept a hardcoded list of items instead of getting smart table to fetch them
                type: Array,
                required: false,
                default: function () {
                    return undefined
                }
            },
            'pdf_view': {          // Indicates if this instance is a PDF view
                type: Boolean,
                required: false,
                default: function () {
                    return false
                }
            },
            userId: {
                type: [Number, String], // Adjust based on your ID format
                required: false,
                default: () => undefined,
            },
        },
        data() {
            return {
                constant: this.constants,
                filters: {
                    search: null,
                    user_id: null,
                    date_due: null,
                },
                fetch_data_response: null,
                currentDate: new Date().toLocaleDateString('en-CA'),
                accountNumber: '',
                firstName: '',
                lastName: '',
                address1: '',
                city: '',
                postalCode: '',
                provinceAbbreviation: ''
            }
        },
         mounted() {
            this.applyUserIdFilter();
             this.fetchUserInfo();
             if (this.member) {
                 this.accountNumber = this.member.internal_code;
                 this.firstName = this.member.first_name;
                 this.lastName = this.member.last_name;
                 this.address1 = this.member.address1;
                 this.city = this.member.city;
                 this.postalCode = this.member.postal_code;
                 this.provinceAbbreviation = this.member.province_abbreviation;
             }
        },

        computed: {
            headers() {
                return [
                    {value: 'user_id', text: 'User ID',        align: ` d-none`,   sortable: false, filterable: true,  search: this?.filters?.user_id   },
                    { text: "Due Date", value: "date_due" ,   sortable: true,   filterable: true, search: this?.filters?.date_due },
                    // { text: "Current Year", value: "current_year" ,   sortable: false,   filterable: false },
                    { text: "Payment Date", value: "date_payment" ,   sortable: false,   filterable: false},
                    { text: "Item Paid", value: "paid_item" ,   sortable: false,   filterable: false},
                    { text: "Payment Mode", value: "type_payment" ,   sortable: false,   filterable: false},
                    // { text: "Cheque or Bank", value: "check_number" ,   sortable: false,   filterable: false},
                    // { text: "Deposit Date", value: "date_deposit" ,   sortable: false,   filterable: false},
                    { text: "Due", value: "amount_due" ,   sortable: false,   filterable: false},
                    { text: "Payment", value: "amount_payment" ,   sortable: false,   filterable: false},
                ];
            },
            filters_used() {
                let filters_used = Object.keys(this.filters).filter(filter => (!!this.filters[filter] && this.filters[filter].length))
                if (filters_used?.length === 4) return "All"
                if (!filters_used || filters_used.length === 0) return ""
                return filters_used?.join(", ").toProperCase()
            },
            num_records_total() {
                return this.fetch_data_response?.data?.recordsTotal
            },
            num_records_filtered() {
                return this.fetch_data_response?.data?.recordsFiltered || this.items?.length
            },
            records_are_present() {
                return this.items?.length || this.fetch_data_response?.data?.data?.length
            },
            balance_previous() {
                return this.balanceData.previous ? this.balanceData.previous?.sum_balance : 0;
            },
            balance_current() {
                return this.balanceData.current ? this.balanceData.current?.sum_balance : 0;
            },
        },
        methods: {
            example() {
                console.log("This is just a test")
            },
            receivedRecordsUpdate(response) {
                this.fetch_data_response = response
            },
            getDefaultItemsPerPage() {
                return this.pdf_view ? -1 : 20
            },
            getDefaultItemsPerPageOptions() {
                return this.pdf_view ? [-1] : [5, 10, 20, 30]
            },
            async exportAsExcel() {
                // await this.$refs.report_list.getExport() /* How it's done when you want to export without queue -- Only exports visible records */
                await this.$refs.report_list.getExcel()
            },
            async exportAsPdf() {
                await this.$refs.report_list.getPdf()
            },
            displayYear(member_due_record) {
                // date_due was previously the only date being considered
                const currentDate = new Date()
                const date_to_use = member_due_record.date_due || member_due_record.date_payment
                const year = new Date(date_to_use).getFullYear()
                return year !== currentDate.getFullYear() ? year + 1 : year
            },
            fetchTotals() {
                if (this.userId) {
                    axios.post(route('memberdues-usertotals', this.userId).url())
                        .then((response) => {
                            this.balance_current = response.data.current?.sum_balance ?? 0;
                            this.balance_previous = response.data.previous?.sum_balance ?? 0;
                            this.fetchUserInfo();
                        })
                        .catch(error => {
                            this.$root.snackbar.error(error.response.data.message || "An error occurred");
                        });
                } else {
                    console.error("User ID is not set. Cannot fetch totals.");
                }
            },
            fetchUserInfo() {
                if (this.$refs.report_list.items_local && this.$refs.report_list.items_local.length > 0) {
                    const userInfo = this.$refs.report_list.items_local[0];
                    this.accountNumber = userInfo.internal_code;
                    this.firstName = userInfo.first_name;
                    this.lastName = userInfo.last_name;
                    this.address1 = userInfo.address1;
                    this.city = userInfo.city;
                    this.postalCode = userInfo.postal_code;
                    this.provinceAbbreviation = userInfo.province_abbreviation;
                }
            },
            applyUserIdFilter() {
                const userId = this.userId
                this.filters.user_id = userId
            },
        },
        watch: {
            items(newItems) {
                if (newItems && newItems.length > 0) {
                    this.fetchTotals();
                }
            },
            userId(newUserId) {
                if (newUserId) {
                    this.fetchTotals();
                    this.fetchUserInfo();
                }
            }
        }


    }
</script>

<style>

#dues-invoice-table td,th {
    height: 24px !important; /* changing to 10pt has no impact */
}

.row-pointer tbody tr {
    cursor: pointer;
}

.account-information {
    text-align: left;
    margin-bottom: 10px;
}

hr {
    margin-top: 5px;
    margin-bottom: 10px;
    border: 0;
    border-top: 1px solid #000;
}

.hidden-filters {
    display: none;
}

@media print {
    .pagebreak {
        page-break-after: always;
        min-height: 1px;
    }

    html, body {
        font-size: 10pt; /* changing to 10pt has no impact */
        margin-top: -50px;
    }

    #dues_invoice_body {
        margin: 0 12px;
        font-family: ABCFavorit,serif;
    }


}
</style>
